var _defs, _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQNav1NotSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-q-nav-1{fill:#fff;}.cls-1-q-nav-1-not-selected{fill:#33b0ce;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DNA-PB-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-q-nav-1",
    cx: 17,
    cy: 17,
    r: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-1-not-selected",
    d: "M17,31A14,14,0,1,1,31,17,14,14,0,0,1,17,31ZM17,4A13,13,0,1,0,30,17,13,13,0,0,0,17,4Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix_Group_590-2",
    "data-name": "prefix  Group 590-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix_Path_1019-2",
    "data-name": "prefix  Path 1019-2",
    className: "cls-1-q-nav-1-not-selected",
    d: "M14.79,12.05l4.36,0A9.5,9.5,0,0,1,17,13.12a9.39,9.39,0,0,1-2.18-1.07M17,14.38a9.41,9.41,0,0,1,2.11,1l-4.21,0a9,9,0,0,1,2.1-1m-3.22,2.24,6.45,0a.93.93,0,0,1,.1.37v0a.79.79,0,0,1-.1.37l-6.45,0a.93.93,0,0,1-.1-.37v0a.93.93,0,0,1,.1-.37m1.13,2,4.21,0A9.13,9.13,0,0,1,17,19.62a9.24,9.24,0,0,1-2.12-1M17,20.88a9.34,9.34,0,0,1,2.06,1L15,21.9a9.64,9.64,0,0,1,2.06-1m4.36-10.82a.6.6,0,0,0-.74-.39.59.59,0,0,0-.38.74h0a.76.76,0,0,1-.06.42l-6.5,0a.75.75,0,0,1-.06-.42.59.59,0,0,0-1.13-.34c0,.1-.3,2.1,2.92,3.65C13,15,12.47,16.39,12.5,17s.54,2.06,3,3.23A6.17,6.17,0,0,0,13.2,22a.59.59,0,0,0-.23.35,2.38,2.38,0,0,0-.37,1.56.6.6,0,0,0,.57.41.57.57,0,0,0,.18,0,.57.57,0,0,0,.38-.73h0a.73.73,0,0,1,.09-.5l6.44,0a.76.76,0,0,1,.09.49.6.6,0,0,0,.39.73.57.57,0,0,0,.18,0,.6.6,0,0,0,.56-.42,2.33,2.33,0,0,0-.39-1.56.54.54,0,0,0-.23-.34,6,6,0,0,0-2.3-1.75C21,19,21.53,17.61,21.5,17s-.54-2.06-3-3.23c3.2-1.59,2.91-3.59,2.88-3.69"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQNav1NotSelected);
export default __webpack_public_path__ + "static/media/q_nav_1_not_selected.42791984.svg";
export { ForwardRef as ReactComponent };